import React, { useState, useEffect } from "react";
import random from "lodash.random";
import isObject from "lodash.isobject";

function Dropdown(props) {
    const { onChange, value, renderItem, items, style } = props;
    const [isActive, setIsActive] = useState(false);
    const [dropdownId, setDropdownId] = useState();

    useEffect(() => {
        setDropdownId(`dropdown-menu-${random(0, 4)}`);
    }, []);

    return (
        <div className={`trpr__dropdown dropdown ${isActive ? "is-active" : ""}`} style={style}>
            <div className="dropdown-trigger">
                <button
                    type="button"
                    onClick={() => setIsActive(!isActive)}
                    className="button"
                    aria-haspopup="true"
                    aria-controls={dropdownId}
                >
                    <span className="text">{renderItem(value)}</span>
                    <span className="icon" aria-hidden="true" />
                </button>
            </div>
            <div className="dropdown-menu" id={dropdownId} role="menu">
                <div className="dropdown-content">
                    {items.map(item => {
                        if (isObject(item)) {
                            if (item.id === value.id) {
                                return null;
                            }
                            return (
                                <li
                                    key={item.id}
                                    onClick={() => {
                                        setIsActive(false);
                                        onChange(item);
                                    }}
                                    className={`dropdown-item ${item.id === value.id ? "is-active" : ""}`}
                                >
                                    <span>{renderItem(item)}</span>
                                </li>
                            );
                        }
                        if (item === value) {
                            return null;
                        }
                        return (
                            <li
                                onClick={() => {
                                    setIsActive(false);
                                    onChange(item);
                                }}
                                className={`dropdown-item ${item === value ? "is-active" : ""}`}
                            >
                                <span>{renderItem(item)}</span>
                            </li>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}

Dropdown.defaultProps = {
    renderItem: value => value,
};

export default Dropdown;
